(() => {
  if (window.mdsCollectionDescriptionLoaded) return;
  window.mdsCollectionDescriptionLoaded = true;
  const headingSelector = 'h1, h2, h3, h4, h5, h6';

  // Keep original headings and their wrappers in place. Only wrap consecutive
  // content without headings, including descriptions nested in imported HTML.
  const prepareText = description => {
    const segments = [];
    const split = parent => {
      let group = [];
      const flush = () => {
        const hasContent = group.some(node => node.textContent.trim() ||
          (node instanceof Element && (node.matches('img, video, iframe, table') ||
            node.querySelector('img, video, iframe, table'))));
        if (hasContent) {
          const text = document.createElement('div');
          text.className = 'collection-description__text';
          text.setAttribute('data-collection-description-text', '');
          parent.insertBefore(text, group[0]);
          group.forEach(node => text.append(node));
          segments.push(text);
        }
        group = [];
      };
      [...parent.childNodes].forEach(node => {
        if (node instanceof Element && node.matches(headingSelector)) {
          flush();
        } else if (node instanceof Element && node.querySelector(headingSelector)) {
          flush();
          split(node);
        } else {
          group.push(node);
        }
      });
      flush();
    };
    split(description);
    return segments;
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-collection-description-toggle]').forEach(button => {
      if (button.dataset.descriptionInitialized) return;
      const description = document.getElementById(button.getAttribute('aria-controls'));
      if (!description) return;
      button.dataset.descriptionInitialized = 'true';
      const segments = prepareText(description);
      const update = () => {
        if (button.getAttribute('aria-expanded') === 'true') return;
        button.hidden = !segments.some(text => text.scrollHeight > text.clientHeight + 1);
      };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        description.classList.toggle('expanded', expanded);
        button.querySelector('[data-collection-description-label]').textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
        if (!expanded) update();
      });
      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(description);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(description)) resizeObserver.disconnect();
      });
      document.fonts?.ready.then(update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
